import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "../../../helpers/axios";
import {useAuth} from "../../auth";
import {SettingsEntry} from "../core/_models";
import {Button} from "react-bootstrap";
import {LoadingIndicator} from "../../common/components/LoadingIndicator";
import {RequestError} from "../../common/components/RequestError";
import { Http } from "../../../helpers/http";

export function SelectApplication() {
    const {refreshUser, setSelectedApplication} = useAuth()

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState<null | SettingsEntry[]>(null);

    const navigate = useNavigate()

    const loadData = async () => {
        setError(false);
        setLoading(true);
        try {
            const {data} = await Http.get<SettingsEntry[]>('get_application_list');
            setData(data)
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const selectApplication = async (application: { id: number }) => {
        setLoading(true);
        try {
            await setSelectedApplication(application.id)
            await refreshUser()
            navigate('/');
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <>
            {loading && <div className="text-center"><LoadingIndicator/></div>}
            {!loading && error && <RequestError onRefresh={loadData}/>}
            {!loading && data && <div className="d-grid gap-2">
                <h3 className="pb-5 text-center">Select Application</h3>
                {data.map(application => <Button
                    key={application.id}
                    variant="primary"
                    size="lg"
                    onClick={() => selectApplication(application)}
                >
                    {application.name} &rarr;
                </Button>)}
            </div>}
        </>
    )
}